import { FC } from 'react';

import { Button } from '../../../../components/ui/Button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '../../../../components/ui/Dialog';
import { Offer } from '../../../../types';

interface Props {
    offer: Offer | null;
    loading: boolean;
    error: string | null;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => void;
}

export const PremiumExtensionDialog: FC<Props> = ({
    offer,
    loading,
    error,
    onOpenChange,
    onConfirm,
}) => {
    const isExtension = offer?.premium_active ?? false;
    const title = isExtension ? 'Продовжити premium?' : 'Активувати premium?';
    const activationCountLabel = isExtension ? 'ще одну' : 'одну';
    const confirmLabel = isExtension
        ? 'Продовжити premium'
        : 'Активувати premium';
    const loadingLabel = isExtension ? 'Продовжуємо...' : 'Активуємо...';

    return (
        <Dialog
            open={offer !== null}
            onOpenChange={(open) => {
                if (!loading) {
                    onOpenChange(open);
                }
            }}
        >
            <DialogContent className="w-[calc(100%-2rem)] sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>
                        Для пропозиції «{offer?.product.name}» буде використано{' '}
                        {activationCountLabel} доступну premium-активацію.
                    </DialogDescription>
                </DialogHeader>

                {error && (
                    <p className="text-sm text-red-600" role="alert">
                        {error}
                    </p>
                )}

                <DialogFooter className="flex-col gap-2 sm:flex-row sm:gap-0">
                    <Button
                        type="button"
                        variant="outline"
                        className="mt-2 w-full sm:mt-0 sm:w-auto"
                        onClick={() => onOpenChange(false)}
                        disabled={loading}
                    >
                        Скасувати
                    </Button>
                    <Button
                        type="button"
                        className="w-full sm:w-auto"
                        onClick={onConfirm}
                        disabled={loading}
                        data-testid="confirm-premium-extension"
                    >
                        {loading ? loadingLabel : confirmLabel}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
